import BrazeClient, { BrazeEvents } from 'AppShell/Braze/BrazeClient';
import { EventNames } from 'AppShell/appshell_types/customEventTypes';

export const BRAZE_SIMULATE_ID = 'BRAZE_SIMULATE_ID';
export const createBrazeEventsSimulator = (braze: BrazeClient) => [
    {
        name: EventNames.SIMULATE_BRAZE_PRODUCT_RATINGS,
        event: () => {
            braze.triggerBrazeEvent(BrazeEvents.TRIGGER_RATE_YOUR_PRODUCT, { messageId: BRAZE_SIMULATE_ID });
        },
    },
];
export default {
    createBrazeEventsSimulator,
};
